import React, {useState, useEffect, useRef} from 'react';
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, CardContent} from '@material-ui/core';
import Swal from "sweetalert2";
import axios from '../../api';
import $ from 'jquery';
import 'datatables.net-dt/css/jquery.dataTables.css';
import 'datatables.net-dt/js/dataTables.dataTables.min.js';
import 'datatables.net/js/jquery.dataTables';
import HelperFormatData from "../../HelperFormatData";
import Visualizar from '../../pages/Actions/Visualizar';
import VisualizarDoenca from "../Actions/VisualizarDoenca";
import EditarDoenca from "../Actions/EditarDoenca";
import ExcluirDoenca from "../Actions/ExcluirDoenca";

const columns = [
    {id: 'id', label: 'Protocolo'},
    {id: 'name', label: 'Nome'},
    {id: 'email', label: 'E-mail'},
    {id: 'cpf', label: 'CPF'},
    {id: 'cns', label: 'CNS'},
    {id: 'created_at', label: 'Data Cadastro'},
    {id: 'acoes', label: 'Ações'},
];

function TabelaFuncionarios() {

    //guarda o estado da tabela
    const [results, setTableData] = useState([]);
    const tableRef = useRef(null);

    useEffect(() => {
        Swal.fire({
            title: 'Carregando...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        const token = localStorage.getItem('token');
        // Faz a chamada HTTP para obter o número de pacientes femininos
        axios.get('/funcionarios', {timeout: 10000, headers: {Authorization: `Bearer ${token}`}})

            .then(response => {
                    const results = response.data.data;
                console.log(results)
                    setTableData(results);

                    // Verifique se o DataTable já foi inicializado na tabela
                    const table = $('#users').DataTable();
                    if ($.fn.DataTable.isDataTable('#users')) {
                        table.destroy();
                    }

                    // Inicialize o DataTable aqui
                    $(document).ready(function () {
                        $('#users').DataTable({
                            language: {
                                url: '//cdn.datatables.net/plug-ins/1.10.25/i18n/Portuguese-Brasil.json'
                            },
                            deferRender: true,
                            destroy: true // adicione essa opção
                        });
                    });
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                Swal.close();
            });
    }, []);

    useEffect(() => {
        if (tableRef.current) {
            $(tableRef.current).DataTable();
        }

    }, [results]);

    return (

        <TableContainer component={Paper}>
            <CardContent>
                <Table id="users" ref={tableRef}>
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell id={"header"} style={{width: column.width}}
                                           key={column.id}>{column.label}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {results.map((result) => (
                            <TableRow key={result.id}>
                                <TableCell>{result.id}</TableCell>
                                <TableCell>{result.usuario?.name}</TableCell>
                                <TableCell>{result.email}</TableCell>
                                <TableCell>{result.cpf}</TableCell>
                                <TableCell>{result.cns}</TableCell>
                                <TableCell>{HelperFormatData(result.created_at)}</TableCell>
                                <TableCell>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        margin: '0 auto',
                                        padding: 2

                                    }}>
                                        <Visualizar
                                            id={Number(result.id)}
                                            title="Detalhes do funcionário"
                                            apiUrl={`https://gerenciamentoatendimento.cloud/api/funcionarios/show/`}
                                        />
                                        <EditarDoenca
                                            id={Number(result.id)}
                                            title="Editar"
                                            apiUrl={`https://gerenciamentoatendimento.cloud/api/funcionarios/show/`}
                                        />
                                        <ExcluirDoenca
                                            id={Number(result.id)}
                                            title="Excluir"
                                            apiUrl={`https://gerenciamentoatendimento.cloud/api/tipodoencas/`}
                                        />
                                    </div>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </CardContent>
        </TableContainer>

    );
}

export default TabelaFuncionarios;
